module.exports = __webpack_public_path__ + "static/media/www.sinunilona.fi.6549b850.jpg";